import * as React from 'react';
import { Icon, Stack, Text } from '@fluentui/react';
import { THEME_ID } from './../shared/styles';
import { CmicContext } from '../context/CmicContext';
import { handleTHEMECLR } from './BorderImage';

const BorderIcon = ({
	label = '',
	iconName = 'Help',
	parentClass,
	parentStyles = {},
	iconStyles = {},
	labelStyles = {},
	onClick,
	children,
}) => {
	const { currentOfficeTheme } = React.useContext(CmicContext);

	const sectionStackTokens = { childrenGap: 10 };

	const parentStackStyles = {
		root: {
			background: currentOfficeTheme.bodyBackgroundColor,
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			border:
				currentOfficeTheme.themeId === THEME_ID.BLACK
					? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
					: '1px solid rgba(174, 180, 189, 1)',
			cursor: 'pointer',
			minWidth: 35,
			minHeight: 35,
		},
	};

	const iconStackStyles = {
		root: { fontSize: 12, color: currentOfficeTheme.controlForegroundColor, marginTop: '3px' },
	};

	const labelStackStyles = {
		root: {
			fontSize: 12,
			color: currentOfficeTheme.bodyBackgroundColor,
		},
	};

	return (
		<Stack
			onClick={onClick}
			styles={parentStackStyles}
			style={parentStyles}
			tokens={sectionStackTokens}
			className={parentClass ? parentClass : handleTHEMECLR(currentOfficeTheme)}
		>
			{children ? (
				children
			) : (
				<>
					<Stack.Item>
						<Icon iconName={iconName} style={iconStyles} styles={iconStackStyles} />
					</Stack.Item>
					{label && (
						<Stack.Item>
							<Text styles={labelStackStyles} style={labelStyles}>
								{label}
							</Text>
						</Stack.Item>
					)}
				</>
			)}
		</Stack>
	);
};

export default BorderIcon;
